export default __webpack_public_path__ + "static/media/Name.d13487fa.svg";